import { Icon, IconProps } from '@chakra-ui/react'

export default function PersonIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={'#077FDE'}
      {...props}
    >
      <path
        d="M13.3333 13.3333V12.8333C13.3333 11.2685 12.0648 10 10.5 10H5.49999C3.93518 10 2.66666 11.2685 2.66666 12.8333V13.3333"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      ,
      <circle
        cx="8.00001"
        cy="4.66667"
        r="2.66667"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
